var customJS = function () {};

/**
 * Function wait CPB DOM elements to show up.
 * Work in modern browsers.
 * And execute callback.
 */
var cpbLoaded = function () {
  document.addEventListener("click", myFunction);

  


  function myFunction() {
    if (jQuery(".cpb-next-tab-button").eq(1).hasClass("cpb-hide")) {
      console.log("CPB has show");
      jQuery(".cpb-add-to-cart-button").addClass("cartshow");
    } else {
      console.log("CPB has hide");
      jQuery(".cpb-add-to-cart-button").removeClass("cartshow");
    }
  }
};

cpbLoaded();

document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
      console.log("CPB has scroll");
jQuery('html,body').animate({
        scrollTop: jQuery(".react-tabs__tab-list").offset().top -70},
        'slow');
});

